import React, { useMemo } from 'react';
import { checkCampaignTabsVisibility, getNotificationNumber } from '../../functions/Functions';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { UserRoles } from '../../../enum/UserRoles';
import { CgMoreVertical } from 'react-icons/cg';
import { Dropdown } from 'react-bootstrap';
import { Languages } from '../../utils/Languages';
import { UserService } from '../../../app/shared/user/service';
import { ErrorToast } from '../../../utils/toasters';
import { actions } from '../../../store/authentication/authRedux';
import { useTranslation } from 'react-i18next';

export interface ITabs {
    tabKey: string;
    title: string;
    icon: React.ComponentType<any>;
    moreTabs?: ITabs[];
}

interface IMobileMenuProps {
    tabs: ITabs[];
    classes: string;
    handleChange: (...args: any) => void;
    activeTabKey: string;
}

const MobileMenuComponent = ({ tabs, classes, handleChange, activeTabKey }: IMobileMenuProps) => {
    const dispatch = useDispatch();
    const locale = useSelector((state: IAllStates) => state.auth.user.locale);
    const userType = useSelector((state: IAllStates) => state.auth.user.userType);
    const isBrandType = userType === UserRoles.BRAND || userType === UserRoles.BRAND_MASTER;
    const isGlobalBrandActive = useSelector((states: IAllStates) => states?.auth?.isGlobalBrand);
    const { redDots } = useSelector((state: IAllStates) => state.redDots);
    const { t } = useTranslation();

    // Memoizovana lista tabova
    const tabsList = useMemo(() => tabs, [tabs]);

    const updateLanguage = (lang: string) => {
        UserService.updateGlobalPreference({ locale: lang })
            .then(data => {
                dispatch(actions.updateLanguage(data.locale));
            })
            .catch(error => ErrorToast(error));
    };

    return (
        <>
            <div className={`tabs-mobile ${classes}`}>
                {tabsList?.map((tab, i: number) => {
                    const { tabKey, title, icon: IconComponent, moreTabs } = tab;

                    return (
                        <div
                            className="tab"
                            onClick={e => {
                                if (tabKey !== 'more') {
                                    handleChange(e, tabKey);
                                }
                            }}
                            hidden={isBrandType && !isGlobalBrandActive ? !checkCampaignTabsVisibility(tabKey) : false}
                            key={title + i}
                        >
                            {tabKey === 'more' ? (
                                <div>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="white" id="dropdown-basic">
                                            <CgMoreVertical
                                                size={24}
                                                color={`${activeTabKey !== tabKey ? '#9ea5ab' : '#fff'}`}
                                            />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="min-width-min-content">
                                            {moreTabs?.map((tabMore, iMore) => {
                                                const {
                                                    tabKey: tabKeyMore,
                                                    title: titleMore,
                                                    icon: IconComponentMore,
                                                } = tabMore;
                                                return (
                                                    <Dropdown.Item
                                                        key={tabKey + iMore}
                                                        onClick={e => {
                                                            handleChange(e, tabKeyMore);
                                                        }}
                                                    >
                                                        <div
                                                            className={`${
                                                                activeTabKey !== tabKeyMore ? 'bg-white' : 'bg-primary'
                                                            } p-2 default-radius w-max-content m-auto`}
                                                        >
                                                            {IconComponentMore && (
                                                                <IconComponentMore
                                                                    width="24"
                                                                    height="24"
                                                                    color={`${
                                                                        activeTabKey !== tabKeyMore ? '#9ea5ab' : '#fff'
                                                                    }`}
                                                                />
                                                            )}
                                                        </div>
                                                        <p className="text-center">{t(titleMore)}</p>
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            ) : (
                                <div
                                    className={`${
                                        activeTabKey !== tabKey ? 'bg-white' : 'bg-primary'
                                    } p-2 default-radius w-max-content m-auto`}
                                >
                                    {IconComponent && (
                                        <IconComponent
                                            width="24"
                                            height="24"
                                            color={`${activeTabKey !== tabKey ? '#9ea5ab' : '#fff'}`}
                                        />
                                    )}
                                </div>
                            )}
                            <p>{t(title)}</p>
                            {!!getNotificationNumber(tabKey, redDots) && (
                                <span className="sidebar-bullet">{getNotificationNumber(tabKey, redDots)}</span>
                            )}
                        </div>
                    );
                })}
            </div>

            <div className="shadow-lg border border-primary default-radius w-max-content m-auto language-badge d-md-none">
                <Dropdown>
                    <Dropdown.Toggle variant="white" id="dropdown-basic">
                        <h6 className="mb-0 text-uppercase text-primary" style={{ lineHeight: 'normale' }}>
                            {locale}
                        </h6>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="min-width-min-content">
                        {Languages.map(lang => {
                            return (
                                <Dropdown.Item onClick={() => updateLanguage(lang.value)} key={lang.value}>
                                    <div>{t(lang.label)}</div>
                                </Dropdown.Item>
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </>
    );
};

export const MobileMenu = React.memo(MobileMenuComponent);
